module.exports = __webpack_public_path__ + "img/headerbg.f4c92b11.png";